<template>
    <section id="container">
        <section id="user-visual" class="mypage">
            <div class="grid--con">
                <div class="user-visual-txt">회사소개<!--<span> 궁금한 점이 있으신가요? 고객센터에서 해결 방법을 찾아보세요.</span>--></div>
            </div>
        </section>
        <div id="content" class="sub">
            <div class="grid--con-sub">
                <img src="../../../../assets/i5gam/images/img-i5gam-cpinfo3.png"/>
                <div class="i5gam-con-grid-both mgt60">
					<h1 class="tit-type3 f-left">주요사업 현황</h1>
					<div class="f-right">
						<ul class="txt-type2-1 depth2">
							<li>국내 최초 어린이집 회계프로그램 걸음마넷 개발 보급</li>
							<li>보육통합시스템 개발, 유지보수 및 기능개선</li>
							<li>서울시 및 경기도 회계관리 시스템 구축 및 운영</li>
							<li>삼성보육재단, 한솔보육재단, 모아맘재단 등 보육 ERP구축 및 운영</li>
							<li>어린이집 전용 문서관리서비스 개발 및 보급</li>
						</ul>
						<ul class="__ct-list __no-space mgt20">
							<li class="__cbg">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list7.png" /></div>
								</div>
							</li>
							<li class="__cbg">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list8.png" /></div>
								</div>
							</li>
							<li class="__cbg">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list9.png" /></div>
								</div>
							</li>
							<li class="mgt10">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list10.png" /></div>
								</div>
							</li>
							<li class="mgt10">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list11.png" /></div>
								</div>
							</li>
							<li class="mgt10">
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list12.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list13.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list14.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list15.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list16.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list17.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list18.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list19.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list20.png" /></div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list21.png" /></div>
								</div>
							</li>
						</ul>
					</div>
				</div>
                <div class="i5gam-con-grid-both mgt80">
					<h1 class="tit-type3 f-left">함께하는 기업</h1>
					<div class="f-right">
						<h2 class="tit-type4">한국 비영리 회계프로그램 사업자 협동조합 <span class="pc02">(한.비.협.)</span></h2>
						<ul class="__ct-list">
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list1.png" /></div>
									</div>
									<div class="__call">1566-2703</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list2.png" /></div>
									</div>
									<div class="__call">02-984-0000</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list3.png" /></div>
									</div>
									<div class="__call">070-5056-0631</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list4.png" /></div>
									</div>
									<div class="__call">1661-3369</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list5.png" /></div>
									</div>
									<div class="__call">1588-4202</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list6.png" /></div>
									</div>
									<div class="__call">053-986-0905</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company"><img src="../../../../assets/i5gam/images/img-i5gam-ct-list22.png" /></div>
									</div>
									<div class="__call">1600-0330</div>
								</div>
							</li>
						</ul>
						<h2 class="tit-type4">기타</h2>
						<ul class="__ct-list">
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company">인텍</div>
									</div>
									<div class="__call">032-224-4309 / 010-5338-4309</div>
								</div>
							</li>
							<!-- <li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company">그물정보시스템</div>
									</div>
									<div class="__call">010-6201-0805</div>
								</div>
							</li> -->
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company">공감</div>
									</div>
									<div class="__call">010-8950-6363</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company">뷰 공감</div>
									</div>
									<div class="__call">010-9041-3392</div>
								</div>
							</li>
							<li>
								<div class="box-type01">
									<div class="dp-tr">
										<div class="__company">키움</div>
									</div>
									<div class="__call">010-5178-0979</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'company'
    }
</script>

<style scoped>

</style>